<div class="card">
    <header class="card__header">
        <main>
            <h4 class="card__title">{{ fullName }}, {{ 'FAMILY_MEMBER_CARD.REG_BR' | translate }}
                <span *ngIf="regId">{{regId}}</span>
                <span *ngIf="!regId"> /</span>
            </h4>
            <small class="card__status">{{ (isFosterParent ? 'CASES.CPSU.FOSTER_PARENT':'CASES.CPSU.FOSTER_CHILD') | translate
                }}</small>
        </main>
        <aside class="card__header-actions">
            <button [routerLink]="subjectDetailsLink" (click)="openDetailsNewTab()" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }" mat-icon-button class="button-square card__button"
                color="primary" matTooltip="{{ 'FAMILY_MEMBER_CARD.TOOLTIP_VIEW' | translate }}">
                <mat-icon class="button-square__icon">visibility</mat-icon>
            </button>
        </aside>
    </header>
</div>